module.exports = "/_next/static/images/link-card-c6de6742fe175e5dd96718e5d0e150a4.png";